import { useContext, useEffect, useState } from "react";
import { getUsers } from "../../services/Lookups";
import AuthContext from "../../context/AuthContext";

import { makeStyles } from "@mui/styles";
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Toolbar from '@mui/material/Toolbar';
import Paper from '@mui/material/Paper';

const useStyles = makeStyles({
  headerBox: {
    color: "#95a2b4",
    fontSize: "13px",
    fontWeight: "bold",
    paddingRight: ".5rem"
  }
});

export default function UsersList() {
  const auth = useContext(AuthContext);
  
  const [users, setUsers] = useState([]);

  const classes = useStyles();

  useEffect(() => {
    getUsers(auth.token)
      .then((response) => {
        if (response.users.length > 0) {
          response.users = response.users.filter(user => user.accounts.includes(auth.userAccountID))
          response.users.forEach((user) => {
            if (auth.userAccount.owners?.includes(user.id)) {user.role = "Owner"}
            else if (auth.userAccount.admins?.includes(user.id)) {user.role = "Admin"}
            else {user.role = "User"}
          })
          setUsers(response.users)
        }
      })
  }, [auth])
  return (
    <Box>
      <Toolbar sx={{ padding: "0 !important"}}>
        <Box className={classes.headerBox} flex={1}>
          Users:
          <br />
          <span style={{ color: "#009cf8", fontSize: "18px" }}>
            {(users?.length) || 0}
          </span>
        </Box>
      </Toolbar>
      <TableContainer component={Paper}>
        <Table aria-label="users table">
          <TableHead>
            <TableRow>
              <TableCell sx={{fontWeight:1000, fontSize: "1rem"}}>Name</TableCell>
              <TableCell sx={{fontWeight:1000, fontSize: "1rem"}} align="right">ID</TableCell>
              <TableCell sx={{fontWeight:1000, fontSize: "1rem"}} align="right">Email</TableCell>
              <TableCell sx={{fontWeight:1000, fontSize: "1rem"}} align="right">Role</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map((user) => (
              <TableRow
                key={user.id}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  {user.name}
                </TableCell>
                <TableCell align="right">{user.id}</TableCell>
                <TableCell align="right">{user.email}</TableCell>
                <TableCell align="right">{user.role}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}